<template>
    <a v-if="outcome.id > 0"
       v-on:click.prevent="processOdd()"
       :id="`mod-${match.matchId}-${outcome.id}`"
       v-bind:class="[
      {
        'bto-sb-odd-lock': outcome.originalDecimalOutcome === '' || outcome.active === false || match.isBetStop || match.suspended || outcome.suspended,
        'bto-sb-event-mormarket-market-odd-active': !IS_AGENT && checkOddActive() && !match.isBetStop,
        'bto-sb-mormarket-odd-active': IS_AGENT && checkOddActive() && !match.isBetStop,
        [updateClasses[`class-${outcome.upDownClass}`]]: true,
      },quickBetClasses ]">
        <div
          v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
          class="bto-sb-spinner-v1"></div>
        <Fragment v-if="isPlayerMarket">
          <div :class="{
            'bto-sb-player-team-jersey': showTeamJerseys,
            'bto-sb-player-home': outcome.teamEnum === 1,
            'bto-sb-player-away': outcome.teamEnum === 2
          }"></div>
          <div class="bto-sb-player-info">
            <div class="bto-sb-event-team"><i>{{ outcome.enrichedOutcomeName || outcome.name }}</i><i>{{formatedOutcome}}</i></div>
            <div class="bto-sb-event-description">{{ showPlayerTeamName && playerTeamName || '' }}</div>
          </div>
        </Fragment>
        <Fragment v-else>
            <i>{{outcome.enrichedOutcomeName || outcome.name}}</i>
            <i>{{formatedOutcome}}</i>
        </Fragment>
    </a>
</template>

<script>
  import MatchOddLiveComponent from './match-odd-live-component';

  export default {
    name: 'MatchOddLiveDetailsComponent',
    /**
     * Inherit all data, props, computed props, methods, mixins from MatchOddLiveComponent
     * see more at https://vuejs.org/v2/api/#Vue-extend
     */
    extends: MatchOddLiveComponent
  };
</script>
